<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/automapai-logo.png" class="header-termhub-logo" alt="AutomapAI" />
      </div>
    </div>
  </header>

  <div>
    <div class="signup-body">
      <div *ngIf="!isTokenExpired">
        <span class="header-text forgot-header-text" [hidden]="token">Forgot Password? </span>
        <span class="header-text forgot-header-text" [hidden]="!token">Reset Password </span>
        <div>
          <div class="form-section">
            <span class="default-font">Don't worry! Happens to the best of us.</span>
            <div class="form-group">
              <app-input
                [for]="'emailFC'"
                label="Email"
                placeholder="Enter your email"
                type="email"
                [control]="emailFC"
                [required]="true"
                (keydown.enter)="onSubmit()"
              ></app-input>
            </div>
            <div class="form-group" [hidden]="!token">
              <div class="input-container h-fit-content">
                <div class="view-password">
                  <app-input
                    *ngIf="!show_eye"
                    [for]="'passwordInputFC'"
                    label="Please create a new password"
                    placeholder="Enter your password"
                    type="password"
                    [control]="passwordFC"
                    [required]="true"
                    (keydown.enter)="onSubmit()"
                  ></app-input>
                  <app-input
                    *ngIf="show_eye"
                    [for]="'passwordInputFC'"
                    label="Please create a new password"
                    placeholder="Enter your password"
                    type="text"
                    [control]="passwordFC"
                    [required]="true"
                    (keydown.enter)="onSubmit()"
                  ></app-input>
                  <div *ngIf="show_eye" class="show-hide-eye default-pointer" (click)="showPassword(false)">
                    <i class="fa-solid fa-eye svg-inline-auth m-t-3"> </i>
                  </div>
                  <div *ngIf="!show_eye" class="show-hide-eye default-pointer" (click)="showPassword(true)">
                    <i class="fa-solid fa-eye-slash svg-inline-auth m-t-3"> </i>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <app-button for="emailResetLinkButton" btnType="login" [hidden]="token" type="submit" (click)="onSubmit()">Email Reset Link</app-button>
              <app-button for="resetButton" btnType="login" [hidden]="!token" type="submit" (click)="onSubmit()">Reset Password</app-button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isTokenExpired" class="new-account mt-3">
        <div>
          <div>Your token is expired!</div>
          <a class="form-link" (click)="onSubmit()">Resend reset password email</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="split right tinted-image"></div>
